export default __webpack_public_path__ + "static/media/ccp-hands.764b8a9c.jpg";